"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHandleColorScheme = void 0;
const react_1 = require("react");
const color_scheme_defaults_1 = require("./color-scheme-defaults");
function useHandleColorScheme(props) {
    const { defaultColorScheme = color_scheme_defaults_1.COLOR_SCHEME_DEFAULTS.defaultColorScheme, getUserSettings, respectSystemSetting, respectUserSettings, setUserSettings, } = props;
    (0, react_1.useEffect)(() => {
        const inverseColorScheme = defaultColorScheme === "light" ? "dark" : "light";
        const userSettings = getUserSettings();
        if ((respectUserSettings && userSettings === inverseColorScheme) ||
            (respectSystemSetting &&
                !userSettings &&
                window.matchMedia(`(prefers-color-scheme: ${inverseColorScheme})`).matches)) {
            document.body.classList.remove(defaultColorScheme);
            document.body.classList.add(inverseColorScheme);
        }
        else {
            document.body.classList.remove(inverseColorScheme);
            document.body.classList.add(defaultColorScheme);
        }
    }, [defaultColorScheme, getUserSettings, respectSystemSetting, respectUserSettings, setUserSettings]);
}
exports.useHandleColorScheme = useHandleColorScheme;
